import React from 'react';
// Components
import LoginForm from '../forms/LoginForm';

function LoginCard() {
  return (
    <section className='grid border-[1px] border-colour6 border-solid rounded-xl lg:container lg:mx-auto lg:max-w-2xl shadow-cardShadow w-full bg-colour1'>
      <div className='grid grid-rows-reg gap-4 w-full h-full px-6 py-6'>
        {/* Header */}
        <header className='grid text-center'>
          <h1 className='text-3xl font-bold leading-tight tracking-tight font-gladolia text-colour2 md:text-2xl dark:text-colour6 '>
            Sign in
          </h1>
        </header>

        {/* Login form */}
        <section>
          <LoginForm />
        </section>
      </div>
    </section>
  );
}

export default LoginCard;
